import { render } from "./UserLogsView.vue?vue&type=template&id=bebb9f02"
import script from "./UserLogsView.vue?vue&type=script&lang=js"
export * from "./UserLogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__